export default __webpack_public_path__ + "static/media/sort.0bfc4104.svg";